import Drawer from '@navi/web-ui/lib/primitives/Drawer/Drawer';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import { useForm } from 'react-hook-form';
import { WaiveFeeDrawerProps, WaiveFeeFormFields } from '../../interfaces/EmiSchedule.type';
import WaiveFeeForm from './WaiveFeeForm';
import { useDispatch } from 'react-redux';
import { submitWaiveFee } from '../../actions/EmiScheduleActions';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { toast, TypeOptions } from '@navi/web-ui/lib/primitives/Toast';
import { formatAmount } from 'src/utils/commonUtils';
import Loader from 'src/components/Loader/Loader';
import '../../../../assets/styles/genericStyles.scss';
import { addClickstreamEvent } from '../../../../service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '../../../../service/clickStream.constant';

const WaiveFeeDrawer = ({
  pendingFeeComponents,
  isOpen,
  toggleDrawer,
  dueDetails,
  phoneNumber = '',
  flowType,
  phoneNumberCustomId = ''
}: WaiveFeeDrawerProps) => {
  const dispatch = useDispatch();
  const {
    loanId = '',
    customerId = '',
    caseBusinessVertical = '',
    caseReferenceId = ''
  } = useParams();

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    resetField,
    setValue,
    reset,
    formState: { errors, isValid }
  } = useForm<WaiveFeeFormFields>({
    mode: 'onChange'
  });
  const [showSubmitLoader, setShowSubmitLoader] = useState(false);
  const [totalWaiverAmountText, setTotalWaiverAmountText] = useState<string | null>(null);
  const formValues = getValues('componentAdjustments');

  const calculateTotalWaiverAmount = (defaultAmtValue: number) => {
    if (!formValues) {
      setTotalWaiverAmountText('');
      return;
    }
    const totalAmt = Object.values(formValues).reduce(
      (total, { requestType, waiverAmount, isFormOpen }) => {
        if (!isFormOpen || !requestType) {
          return total;
        }
        if (waiverAmount) {
          const { value } = waiverAmount;
          if (value <= defaultAmtValue && value > 0) {
            total += value;
          } else {
            total += defaultAmtValue;
          }
        }
        return total;
      },
      0
    );
    setTotalWaiverAmountText(totalAmt > 0 ? formatAmount(totalAmt, false) : '');
  };

  const paymentCallback = (toastMsg: string, msgType: TypeOptions) => {
    toggleDrawer(false);
    setShowSubmitLoader(false);
    reset();
    toast(toastMsg, { type: msgType });
  };

  const handleWaiveFeeSubmit = (data: WaiveFeeFormFields) => {
    if (!dueDetails) {
      return;
    }
    setShowSubmitLoader(true);
    dispatch(
      submitWaiveFee(
        loanId,
        customerId,
        caseReferenceId,
        caseBusinessVertical,
        data.componentAdjustments,
        dueDetails,
        phoneNumber,
        paymentCallback,
        flowType[dueDetails.referenceId],
        phoneNumberCustomId
      )
    );
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_EMISchedule_WaiveSubmit, { ...data });
  };

  return (
    <form>
      <Drawer
        style={{ overflow: showSubmitLoader ? 'visible' : 'auto' }}
        open={isOpen}
        onClose={() => {
          toggleDrawer(false);
          addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_EMISchedule_WaiveCrossClick);
        }}
        headerText="Waive fee"
        footer={
          <Button fullWidth disabled={!isValid} onClick={handleSubmit(handleWaiveFeeSubmit)}>
            Submit
          </Button>
        }
      >
        {isOpen &&
          pendingFeeComponents.map(pendingFeeComponent => (
            <WaiveFeeForm
              key={pendingFeeComponent.dueComponentReferenceId}
              pendingFeeComponent={pendingFeeComponent}
              register={register}
              errors={errors}
              watch={watch}
              index={pendingFeeComponent.dueComponentReferenceId}
              resetField={resetField}
              calculateTotalWaiverAmount={calculateTotalWaiverAmount}
              setValue={setValue}
              flowType={flowType[dueDetails.referenceId]}
              reset={reset}
              dueDetails={dueDetails}
            />
          ))}
        <Loader show={showSubmitLoader} className="overlay white" animate={false} />
      </Drawer>
    </form>
  );
};

export default WaiveFeeDrawer;
